// LIBRARIES
import dayjs from "dayjs";

//REDUX
import { createSlice } from "@reduxjs/toolkit";

//MISC
import { getAllPayments } from "api/paymentsApi";
import { IPaymentsApiParams, PaymentsTableData } from "models/interfaces";

export interface ISessionInitialState {
  isLoading: boolean;
  errorMessage: string;
  paymentsTotalPages: number;
  paymentsTableData: PaymentsTableData[];
  paymentsFilters: IPaymentsApiParams;
  selectedPaymentsReportType: string;
}

const initialState: ISessionInitialState = {
  isLoading: false,
  errorMessage: "",
  paymentsTotalPages: 0,
  paymentsTableData: [],
  paymentsFilters: {
    userFullName: {
      usernameOrPhoneNumber: "",
    },
    startDate: "",
    endDate: "",
    page: "",
  },
  selectedPaymentsReportType: "",
};

export const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    togglePaymentsFiltersUserFullNameState: (state, action) => {
      state.paymentsFilters.userFullName = action.payload;
    },
    togglePaymentsFiltersStartDateState: (state, action) => {
      state.paymentsFilters.startDate = action.payload;
    },
    togglePaymentsFiltersEndDateState: (state, action) => {
      state.paymentsFilters.endDate = action.payload;
    },
    togglePaymentsFiltersPageState: (state, action) => {
      state.paymentsFilters.page = action.payload;
    },
    toggleClearPaymentsFiltersState: (state) => {
      state.paymentsFilters = {
        userFullName: {
          usernameOrPhoneNumber: "",
        },
        startDate: "",
        endDate: "",
        page: "",
      };
    },
    toggleClearPaymentsTableData: (state) => {
      state.paymentsTableData = null;
    },
    toggleSelectedPaymentsReportType: (state, action) => {
      state.selectedPaymentsReportType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPayments.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getAllPayments.fulfilled, (state, action) => {
      state.isLoading = false;
      let data = action.payload.content;
      let initialData = Array.from({ length: data.length }, () => ({
        fullName: "",
        creationDate: "",
        amount: "",
        isRefund: "",
      }));
      data.forEach((item, index) => {
        initialData[index] = {
          fullName: item?.customer?.user?.fullName || "NO_NAME_PROVIDED",
          creationDate: dayjs(item.creationDate).format("DD/MM/YYYY"),
          amount: item.amount ? `${item.amount / 100} RON` : "0 RON",
          isRefund: item.isRefund === false ? "No" : "Yes",
        };
      });
      state.paymentsTableData = initialData;
      state.paymentsTotalPages = action.payload.totalPages;
    });
    builder.addCase(getAllPayments.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
  },
});

//eslint-disable-next-line
export const {
  togglePaymentsFiltersUserFullNameState,
  togglePaymentsFiltersStartDateState,
  togglePaymentsFiltersEndDateState,
  togglePaymentsFiltersPageState,
  toggleClearPaymentsFiltersState,
  toggleClearPaymentsTableData,
  toggleSelectedPaymentsReportType,
} = paymentsSlice.actions;

export const paymentsData = (state) => state.payments.paymentsTableData;
export const paymentsTotalPages = (state) => state.payments.paymentsTotalPages;
export const paymentsFilters = (state) => state.payments.paymentsFilters;
export const selectedPaymentsReportTypes = (state) =>
  state.payments.selectedPaymentsReportType;

export default paymentsSlice.reducer;
